import { getMyContainerRepairedDataEn } from "constants-lib/seo/faqDataImplementation"
import { addJSONLDToHead, removeElement } from "./jsonLD.js"

const getMyContainerRepairedEn = () => {
  const data = getMyContainerRepairedDataEn.map((item) => ({
    "@type": `Question`,
    name: item.Question,
    acceptedAnswer: {
      "@type": `Answer`,
      text: item.Answer,
    },
  }))
  return data
}

/* Add FAQ Baster JSON LD if needed, otherwise make sure it does not exist in Head. */
export const addgetMyContainerRepaired = () => {
  if (
    window.location.href.includes(
      `/us/en/support/faqs/how-do-i-get-my-container-repaired`,
    ) &&
    document.getElementById(`getMyContainerRepairedJSONLD`) === null
  ) {
    const script = getMyContainerRepairedJSONLDEn()
    addJSONLDToHead(script, `getMyContainerRepairedJSONLD`)
  } else {
    removeElement(`getMyContainerRepairedJSONLD`)
  }
}

// JSON LD template for FAQ Bagster
const getMyContainerRepairedJSONLDEn = () => {
  const FaqBagsterTemplate = {
    "@context": `http://schema.org`,
    "@type": `FAQPage`,
    mainEntity: getMyContainerRepairedEn(),
  }
  return FaqBagsterTemplate
}
